'use client';
import { classes } from '@/utils/classes/classes';
import { RichTextHeading } from '@/app/components/rich-text/subcomponents/heading';
import type { StaticContentBodyItem } from '@/types/aggregation/static';

type StaticPageImageImageProps = {
    mobileSrc?: string;
    desktopSrc?: string;
    imageLink?: {
        uid?: string;
        [key: string]: unknown;
    };
    textItems: StaticContentBodyItem['items'] | null;
};

const Image = ({ mobileSrc, desktopSrc, imageLink, textItems }: StaticPageImageImageProps) => {
    const hasText = !!textItems && textItems?.length > 0;
    const imgSrc = hasText ? desktopSrc : mobileSrc;
    if (!imgSrc?.length) {
        return null;
    }

    const url = imageLink?.uid;

    const imgProps = {
        src: imgSrc,
        srcSet: !hasText ? `${mobileSrc}${desktopSrc} ${desktopSrc?.length ? `, ${desktopSrc} 909w` : ''}` : '',
        sizes: !hasText ? '90vw' : '',
        className: classes('image-text-image', url && 'clickable'),
        onClick: () => !!url && (window.location.href = url)
    };

    return (
        <div className={classes('image-text-area', hasText && 'contain-text')}>
            <img {...imgProps} loading="lazy" alt="" />
            {textItems?.map((item, idx) => {
                const title = item?.title_content?.[0];
                const content = item?.text_content?.[0]?.text;

                return (
                    <div key={idx} className="title-and-text" id={title?.text?.replaceAll(' ', '_')}>
                        {title && <RichTextHeading className="rich-text-title" {...title} />}
                        {content && <div className="rich-text-content">{content}</div>}
                    </div>
                );
            })}
        </div>
    );
};

export default Image;
